import { removeAllTagsFromMarkdown } from '../../../utils/markdown';
import { ACCESSORIES, CHARGING, WHEELS } from './constants';
import gtmChargingAccessorySelect from '../../../core/gtm/gtmChargingAccessorySelect';
import gtmWheelsSelect from '../../../core/gtm/gtmWheelsSelect';
import gtmAccessorySelect from '../../../core/gtm/gtmAccessorySelect';
function handleGtmEventsForAccessories({ accessory, model, trim, gtmBodyStyle, inventoryStatus }) {
    var _a;
    const accessoryGtmName = accessory === null || accessory === void 0 ? void 0 : accessory.accessoryGtmName;
    const payload = {
        model,
        trim: removeAllTagsFromMarkdown(trim),
        gtmBodyStyle,
        availabilityFlag: inventoryStatus,
    };
    switch ((_a = accessory === null || accessory === void 0 ? void 0 : accessory.category) === null || _a === void 0 ? void 0 : _a.id) {
        case WHEELS:
            return gtmWheelsSelect({
                ...payload,
                wheelsSelected: accessoryGtmName,
            });
        case CHARGING:
            return gtmChargingAccessorySelect({
                ...payload,
                evItem: accessoryGtmName,
            });
        case ACCESSORIES:
            return gtmAccessorySelect({
                ...payload,
                accessoriesSelected: accessoryGtmName,
            });
        default:
            break;
    }
}
export default handleGtmEventsForAccessories;
